<!--
  质控结果下拉选择组件
  使用示例：
  <select-qc-task-id-list v-model="search.qcTaskId"></select-qc-task-id-list>
-->
<template>
  <el-select
    size="small"
    clearable
    placeholder="请选择"
    :value="curValue"
    @change="handleInput"
  >
    <el-option
      v-for="item in options"
      :key="item.value"
      :label="item.label"
      :value="item.value"
      style="color: red"
    >
    </el-option>
  </el-select>
  <!-- <base-el-select v-model="value" :options="curOptions" @input="handleInput" /> -->
</template>

<script>
// import BaseElSelect from './BaseElSelect.vue';
export default {
  name: 'SelectQcTaskIdList',
  props: ['value', 'options'],
  // components: {
  //   BaseElSelect
  // },
  data: () => {
    return {
      curValue: []
    }
  },
  watch: {
    value(val) {
      this.curValue = val;
    },
  },
  methods: {
    handleInput(val) {
      this.$emit('input', val);
    }
  }
}
</script>
